import SitesLocalStorageService from './sitesLocalStorageService.js';
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace SearchLocalStorageService
 */
class SearchLocalStorageService {
    constructor() {
    }

    getRecentSearchData() {
        //check local storage for our search data
        if(SitesLocalStorageService.getItem("globalRecentSearches")) {
            return SitesLocalStorageService.getItem("globalRecentSearches");
        }
        return [];
    }

    setRecentSearchData(item) {
        let recentSearches = JSON.parse(SitesLocalStorageService.getItem("globalRecentSearches"));

        if(recentSearches) {
            //check for the same search value in array
            let tempArr = [];
            tempArr[0] = item;
            for(let i = 0; i < recentSearches.length; i++) {
                if(recentSearches[i].itemName != item.itemName) {
                    tempArr.push(recentSearches[i]);
                }
            }
            if(tempArr.length > 8) {
                tempArr = tempArr.slice(0, 8);
            }
            // var globalRecentSearches = tempArr;
            SitesLocalStorageService.writeItem("globalRecentSearches", JSON.stringify(tempArr));
        } else {
            let globalRecentSearches = [item];
            SitesLocalStorageService.writeItem("globalRecentSearches", JSON.stringify(globalRecentSearches));
        }
    }

    deleteRecentSearchData() {
        SitesLocalStorageService.removeItem("globalRecentSearches");
    }
}

export default new SearchLocalStorageService();
